import React from "react";
import { useTranslation } from "react-i18next";
import { calendarHolidays, CalendarHolidays } from "@planzone/dto";
import {
  useCreateCalendarHolidays,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Form } from "./form";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function CalendarHolidaysCreation({ cancel }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { isRequestPending, createCalendarHolidays } =
    useCreateCalendarHolidays();
  const [formData, setFormData] =
    React.useState<CalendarHolidays>(calendarHolidays);

  return (
    <Modal header={t("calendarHolidays.creation.title")} close={cancel}>
      <form
        className={styles.calendarHolidaysCreation}
        onSubmit={(e) => {
          e.preventDefault();

          !isRequestPending &&
            createCalendarHolidays({
              planzone,
              calendarHolidays: formData,
            });
        }}
      >
        <div className={styles.form}>
          <Form formData={formData} edit={setFormData} />
        </div>
        <div className={styles.footer}>
          <Button type="cancel" press={cancel}>
            {t("calendarHolidays.creation.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
          >
            {t("calendarHolidays.creation.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { CalendarHolidaysCreation };
